export enum RecruitToHireStep {
  CreateJobRequest = "Create Job Request",
  AddCandidates = "Add Candidates",
  Interviews = "Conduct Interviews",
  NoCandidateSelected = "Select Candidate",
  WaitingForEmploymentApp = "Complete Employment Application",
  WaitingForNewHireRequest = "Submit New Hire Request",
  WaitingForNewHireApproval = "Approve New Hire Request",
  WaitingForSignedOfferLetter = "Accept Offer Letter",
  WaitingForOnboardingAcks = "Acknowledge Onboard Documents",
  WaitingForVirtualOrientation = "Confirm Onboard Documents",
  OnboardCompleted = "Complete Onboarding",
}